import type { GenerateUploadUrl } from "@gettactic/components/src/form/FileUploadInput";
import { api } from "@/lib/api/api";

/**
 * Signed upload slot for a ticket file, as the signed-in user. Shared by every
 * authenticated surface that uploads to a request — `file_upload` fields and
 * comment attachments alike. Guests go through the share-link equivalent in
 * `useSharedRequestMutations` instead.
 */
export const generateTicketUpload: GenerateUploadUrl = async (filename) => {
  const res = await api.client.workplaceRequests.generateUploadUrl(filename);
  if (!res.ok || !res.result) {
    throw new Error("Failed to get upload URL");
  }
  return res.result;
};
